export default "__VITE_ASSET__L58IBR$e__"